"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
require("./layout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Layout = exports.Layout = function Layout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "layout_container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex",
    style: {
      flexGrow: "1"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "main_container"
  }, children !== null && children !== void 0 ? children : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Outlet, null))));
};